<template>
  <el-form-item :label="currentField.label" :label-width="currentField.labelWidth + 'px'">
    <el-input
        type="textarea"
        :rows="2"
        :placeholder="currentField.isPlaceholderVisible ? currentField.placeholder : ''"
        v-model="currentField.componentValue"
        v-bind="attributesBinding"
        v-on:change="textAreaChange"
        class="custom-textarea"
    ></el-input>
    <!-- Show copy button if placeholder text length is greater than 1 -->
    <el-button v-if="showCopyButton" type="primary" size="mini" icon="el-icon-document-copy" @click="copyPlaceholder"></el-button>
  </el-form-item>
</template>

<script>
export default {
  name: 'LongTextInput',
  props: ['currentField'],
  data() {
    return {
      // textarea: ''
    };
  },
  methods: {
    textAreaChange(value) {
      this.currentField.componentValue = value;
    },
    copyPlaceholder() {
      // Check if navigator.clipboard is supported
      if (navigator.clipboard && navigator.clipboard.writeText) {
        // Copy placeholder text to clipboard
        navigator.clipboard.writeText(this.currentField.placeholder)
            .then(() => {
              // Success message or any other action
              this.$message.success('Placeholder text copied to clipboard');
            })
            .catch(err => {
              console.error('Failed to copy placeholder text: ', err);
              this.$message.error('Failed to copy placeholder text');
            });
      } else {
        // Fallback for browsers that do not support clipboard API
        console.warn('Clipboard API not supported in this browser');
        // You can provide a fallback mechanism here, such as using a library like clipboard.js
        // or displaying a message to the user that the feature is not available
      }
    }

  },
  computed: {
    attributesBinding() {
      var attr = {};
      if (this.currentField.disabled) {
        attr.disabled = this.currentField.disabled;
      }
      return attr;
    },
    showCopyButton() {
      // Show copy button if placeholder text length is greater than 1
      return this.currentField.isPlaceholderVisible && this.currentField.placeholder && this.currentField.placeholder.length > 1;
    }
  },
};
</script>
